export enum EDegradedSubscriptionStatus {
  PAUSED = "paused",
  CANCELLED = "cancelled",
}

export const degradedSubscriptionStatusAsString = (status: EDegradedSubscriptionStatus | string): string => {
  switch (status) {
    case EDegradedSubscriptionStatus.PAUSED:
      return "Suspendu";
    case EDegradedSubscriptionStatus.CANCELLED:
    default:
      return "Inconnu";
  }
};

